import LanguageDetector from 'i18next-browser-languagedetector';
import 'intl-pluralrules';
import i18n from 'i18next';
import enTrans from './react-i18next/en.json'; // 英语
import zhCnTrans from './react-i18next/zh-cn.json'; // 简体中文
import thTrans from './react-i18next/th.json'; // 泰语
import zhTwTrans from './react-i18next/zh-tw.json'; // 繁体中文
import idTrans from './react-i18next/id.json'; // 印尼语
import msTrans from './react-i18next/ms.json'; // 马来文
import jaTrans from './react-i18next/ja.json'; // 日语
import koTrans from './react-i18next/ko.json'; // 韩语
import ptTrans from './react-i18next/pt.json'; // 葡萄牙语
import esTrans from './react-i18next/es.json'; // 西班牙
import arTrans from './react-i18next/ar.json'; // 阿拉伯语
import viTrans from './react-i18next/vi.json'; // 越南语
import { initReactI18next } from 'react-i18next';
i18n
  .use(LanguageDetector) // 嗅探当前浏览器语言
  .use(initReactI18next) // init i18next
  .init({
    compatibilityJSON: 'v3',
    // 引入资源文件
    resources: {
      en: {
        translation: enTrans,
      },
      zhTw: {
        translation: zhTwTrans,
      },
      zhCn: {
        translation: zhCnTrans,
      },
      th: {
        translation: thTrans,
      },
      id: {
        translation: idTrans,
      },
      ms: {
        translation: msTrans,
      },
      ja: {
        translation: jaTrans,
      },
      ko: {
        translation: koTrans,
      },
      pt: {
        translation: ptTrans,
      },
      es: {
        translation: esTrans,
      },
      ar: {
        translation: arTrans,
      },
      vi: {
        translation: viTrans,
      },
    },
    // 选择默认语言，选择内容为上述配置中的key
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
